import MiamiMovePage from './miami-move-page';
export default MiamiMovePage;